import { apiUrl } from "../../../utils/api";
import { apiBasePath } from "../../BasicUrl";

const OrdersData = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        getOrderListApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.orderLists}`,
                method: "POST",
                body: data,
            }),
        }),
        orderDetail: build.mutation({
            query: (data) => ({
                url: `${apiUrl.orderDetails}`,
                method: "POST",
                body: data,
            })
        }),
        orderStatusUpdate: build.mutation({
            query: (data) => ({
                url: `${apiUrl.orderStatusUpdate}`,
                method: "PUT",
                body: data
            }),
        }),

    }),
    overrideExisting: false,
});
export const { useGetOrderListApiMutation, useOrderDetailMutation, useOrderStatusUpdateMutation } = OrdersData;